/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailConfig,
  GuardrailConfig$inboundSchema,
  GuardrailConfig$Outbound,
  GuardrailConfig$outboundSchema,
} from "./guardrailconfig.js";

export type GuardrailsPolicy = {
  /**
   * Team this policy targets; null for the org-wide policy
   */
  teamId: string | null;
  guardrails: Array<GuardrailConfig>;
  /**
   * Unix timestamp of when the policy was last updated
   */
  updatedAt: number;
};

/** @internal */
export const GuardrailsPolicy$inboundSchema: z.ZodType<
  GuardrailsPolicy,
  z.ZodTypeDef,
  unknown
> = z.object({
  team_id: z.nullable(z.string()),
  guardrails: z.array(GuardrailConfig$inboundSchema),
  updated_at: z.number(),
}).transform((v) => {
  return remap$(v, {
    "team_id": "teamId",
    "updated_at": "updatedAt",
  });
});
/** @internal */
export type GuardrailsPolicy$Outbound = {
  team_id: string | null;
  guardrails: Array<GuardrailConfig$Outbound>;
  updated_at: number;
};

/** @internal */
export const GuardrailsPolicy$outboundSchema: z.ZodType<
  GuardrailsPolicy$Outbound,
  z.ZodTypeDef,
  GuardrailsPolicy
> = z.object({
  teamId: z.nullable(z.string()),
  guardrails: z.array(GuardrailConfig$outboundSchema),
  updatedAt: z.number(),
}).transform((v) => {
  return remap$(v, {
    teamId: "team_id",
    updatedAt: "updated_at",
  });
});

export function guardrailsPolicyToJSON(
  guardrailsPolicy: GuardrailsPolicy,
): string {
  return JSON.stringify(
    GuardrailsPolicy$outboundSchema.parse(guardrailsPolicy),
  );
}
export function guardrailsPolicyFromJSON(
  jsonString: string,
): SafeParseResult<GuardrailsPolicy, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GuardrailsPolicy$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GuardrailsPolicy' from JSON`,
  );
}
